import { Box, CircularProgress } from "@mui/material";
import { useAppState } from "Context/StateContext";
import React from "react";

const Unauthorized = () => {
  const { loadingPermission } = useAppState();

  if (loadingPermission) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={60} thickness={4} sx={{ color: "#0055A4" }} />
      </Box>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 160px)",
      }}
    >
      <div style={{ width: "80vw", height: "auto", padding: 30, backgroundColor: "#e7f0fd" }}>
        <p
          style={{
            fontSize: "16pt",
            color: "#174176",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          You do not have permission to access this page.
        </p>
        <p
          style={{
            fontSize: "16pt",
            color: "#174176",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Please close the window and ensure that you are using the correct account.
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;
